/* eslint-disable react/react-in-jsx-scope */
import { ObservableArray } from "../../models/ObservableArray";

import { Fragment } from "jsx-pragmatic";
// eslint-disable-next-line no-unused-vars
import {
  node,
  Comment,
  domRenderer,
  jsxWatch,
} from "venuescanner-js/tools/jsx";
// watches for changes in the items of an array and then renders then if items contain the _id parameter
const makeChangesToElements = async ({
  array,
  itemToElement,
  order,
  placeHolder,
  component,
  callback,
}) => {
  // console.log(array)
  try {
    // detect order change
    const existingUpdate = array.filter((item) => order.includes(item));
    const existingRendered = order.filter((item) => array.includes(item));
    let orderChanged = false;
    existingUpdate.forEach((item, idx) => {
      if (existingRendered[idx] !== item) orderChanged = true;
    });

    // Add items
    const newItems = array.filter((item) => !order.includes(item));
    await Promise.all(
      newItems.map((item) => {
        return new Promise((resolve, reject) => {
          const flags = {
            createdRef: false,
            insertedElement: false,
            element: null,
          };
          const newIdx = array.indexOf(item);
          const el = component(item, (element) => {
            itemToElement.push({ item, element });
            flags.createdRef = true;
            flags.element = element;
            if (flags.createdRef && flags.insertedElement)
              resolve(flags.element);
          }).render(domRenderer);
          const nextItem =
            newIdx + 1 >= array.length ? null : array[newIdx + 1];
          // console.log({newIdx, nextItem})
          let insertBeforeItemElement = nextItem
            ? itemToElement.find(({ item }) => item === nextItem)
            : null;
          if (insertBeforeItemElement)
            insertBeforeItemElement = insertBeforeItemElement.element;
          if (!insertBeforeItemElement) insertBeforeItemElement = placeHolder;
          order.splice(newIdx, 0, item);
          if (el instanceof Array) {
            while (el.length) {
              const toInsert = el.shift();
              insertBeforeItemElement.parentElement &&
                insertBeforeItemElement.parentElement.insertBefore(
                  toInsert,
                  insertBeforeItemElement
                );
            }
          } else {
            // console.log(el, insertBeforeItemElement)
            insertBeforeItemElement.parentElement &&
              insertBeforeItemElement.parentElement.insertBefore(
                el,
                insertBeforeItemElement
              );
          }
          flags.insertedElement = true;
          if (flags.createdRef && flags.insertedElement) resolve(flags.element);
        });
      })
    );
    // Remove items
    const removeItems = order.filter((item) => !array.includes(item));
    // console.log({removeItems})
    removeItems.forEach((item) => {
      const foundItem = itemToElement.find(
        (itemElement) => itemElement.item === item
      );
      if (foundItem) {
        const idx = itemToElement.indexOf(foundItem);
        itemToElement.splice(idx, 1);
        const el = foundItem.element;
        if (el.parentElement) el.parentElement.removeChild(el);
        order.splice(order.indexOf(item), 1);
      }
    });

    // Reorder items
    if (orderChanged) {
      array.forEach((arrayItem) => {
        // console.log(arrayItem)
        // const oldIdx = order.indexOf(arrayItem)
        // let idx = array.indexOf(arrayItem)
        try {
          // console.log(id, idx, oldIdx)
          // if (oldIdx !== idx) {
          // if (oldIdx<idx) idx++
          // console.log(`Replacing item at ${idx}`)
          // const nextItem = idx+1 >= array.length ? array[idx+1] : null
          // const insertBeforeElement = nextItem ? itemToElement.find(({item}) => item === nextItem ).element : placeHolder
          const insertBeforeElement = placeHolder;
          const insertElement = itemToElement.find(
            ({ item }) => item === arrayItem
          ).element;
          // const insertBeforeElement = (idx >= idOrder.length) ? placeHolder : idElements[idOrder[idx]]
          // console.log(idElements[id], insertBeforeElement)
          insertBeforeElement.parentElement.insertBefore(
            insertElement,
            insertBeforeElement
          );
          // console.log(idOrder.join(","))
          // idOrder.splice(idx, 0, idOrder.splice(oldIdx, 1)[0])
          // console.log(idOrder.join(","))
          // }
        } catch (e) {
          console.error(e);
        }
      });
    }
    order = array.map((i) => i);
  } catch (e) {
    console.error(e);
    throw e;
  }
  callback();
};

export const ArrayComponents = (
  array,
  component,
  { filter = null } = {
    filter: null,
  }
) => {
  jsxWatch("watch=()");
  let changed = false;
  let processingChange = false;
  if (array instanceof ObservableArray) {
    const info = {
      placeHolder: null,
      order: array.map((i) => i),
      itemToElement: [],
    };
    if (array && array.watch) {
      // This array can be watched correctly
      const processChange = async () => {
        processingChange = true;
        // console.log('~------------ processChange -------------')
        if (!info.placeHolder || !info.placeHolder.parentElement)
          throw new Error("Array not in DOM");

        await new Promise((resolve, reject) => {
          try {
            makeChangesToElements({
              array: filter ? array.filter(filter) : array.get(),
              component,
              ...info,
              callback: resolve,
            });
          } catch (e) {
            reject(e);
          }
        });
        processingChange = false;
        // console.log('------------- array changed -------------')
        if (changed) {
          changed = false;
          processChange();
        }
      };
      array.watch(() => {
        // console.log('+------------ array change -------------')
        if (processingChange) {
          changed = true;
        } else {
          changed = false;
          processChange();
        }
      }, true);
    }
    return (
      <Fragment>
        {array.filter(filter).map((item) => {
          return component(item, (element) => {
            info.itemToElement.push({ item, element });
          });
        })}
        <Comment
          ref={(el) => {
            info.placeHolder = el;
          }}
          text="array placeholder"
        />
      </Fragment>
    );
  }
  return null;
};
